<footer>
	<div class="row container-xxl mx-auto py-4 py-lg-5 mt-lg-5">
		<!-- LOGO + ADDRESS -->
		<div class="col-12 col-lg-4">
			<div>
				@if (market) {
					@if (market === "ES") {
						<img
							loading="lazy"
							[src]="wcmService.logoSpainUrl"
							alt=""
							style="width: 100px"
						/>
					} @else {
						<img
							loading="lazy"
							[src]="wcmService.logoUrl"
							alt=""
							class="w-auto"
						/>
					}
				}
			</div>
			<address
				class="text-sm mt-3"
				[innerHTML]="'footer.companyData' | translate"
			></address>
		</div>

		<!-- LINKS -->
		<nav class="col-12 col-lg-4 fw-bold pt-3 mb-3">
			<div class="row">
				<div class="col-6">
					<a
						class="d-block py-1"
						routerLink="/private"
					>
						{{ "menu.auctions" | translate }}
					</a>

					<a
						class="d-block py-1"
						routerLink="/private/live"
					>
						{{ "header.link.live" | translate }}
					</a>

					<a
						class="d-block py-1"
						routerLink="/private/purchase-summary"
					>
						{{ "menu.purchaseSummary" | translate }}
					</a>
				</div>

				<div class="col-6">
					@if (partner && market === "IT") {
						<a
							class="d-block py-1"
							routerLink="/private/partner"
						>
							{{ "menu.ourPartners" | translate }}
						</a>
					}

					<a
						class="d-block py-1"
						routerLink="/private/user-profile"
					>
						{{ "userProfile.profile" | translate }}
					</a>

					<a
						class="d-block py-1"
						routerLink="/private/support"
					>
						{{ "menu.help" | translate }}
					</a>
				</div>
			</div>
		</nav>

		<!-- CONTACT -->
		<address class="col-12 col-lg-4 bg-white mb-0 p-3 ps-4 fw-bold rounded-1 d-flex flex-column justify-content-center">
			<strong class="text-red mb-1">
				{{ "footer.contactUs" | translate }}
			</strong>

			<a
				class="before-ico ico-mail mb-1"
				[href]="'mailto:' + ('footer-app-and-contacts.email' | translate)"
			>
				<span>{{ "footer-app-and-contacts.p8" | translate }}</span>
			</a>

			<a
				class="before-ico ico-phone"
				[href]="'tel:' + ('footer-app-and-contacts.tel' | translate)"
			>
				<span>{{ "footer-app-and-contacts.tel" | translate }}</span>
			</a>
		</address>
	</div>
	<div class="redGradient">
		<div class="d-flex justify-content-end flex-column flex-lg-row container-xxl mx-auto text-white text-uppercase text-xs">
			<span class="align-self-lg-start me-lg-auto px-4 ps-lg-0 py-2 py-lg-3">{{ "footer.copyright" | translate }}</span>
			@if (market === "FR") {
				<a
					class="px-4 py-2 py-lg-3"
					routerLink="/private/accessibility"
				>
					{{ "footer.accessibility" | translate }}
				</a>
			}
			@if (["FR", "ES", "DE"].includes(market)) {
				<a
					class="px-4 py-2 py-lg-3"
					routerLink="/private/legal-notes"
				>
					{{ "footer.legalNotices" | translate }}
				</a>
			}
			<a
				class="px-4 py-2 py-lg-3"
				routerLink="/private/private-privacy"
			>
				{{ "footer.privacy-policy" | translate }}
			</a>

			<a
				class="px-4 py-2 py-lg-3"
				routerLink="/private/terms-and-conditions"
			>
				{{ "footer.termsConditions" | translate }}
			</a>

			<a
				class="ps-4 py-2 py-lg-3"
				href="javascript:getCookieOpenModal()"
			>
				{{ "menu.cookie" | translate }}
			</a>
		</div>
	</div>
</footer>